import Platform from './Platform'
import Android from './Android'
import Ios from './Ios'

// 获取平台对应实例
Platform.getInstance = function() {
  let ret = null;
  switch(this.plt) {
    case 'ios':
      ret = new Ios()
    case 'android':
      ret = new Android()
  };
  return ret;
}

export default Platform